import React from 'react';
import './History.css';

import { Heading } from '../../../components';
import { history } from '../../../constants';



const History = () => {

  return (
    <section className="history">

      {/* History Heading */}
      <Heading title={'Our History'} subTitle={"Our Journey"} />

      {/* All historical timeline items */}
      <div className="box-container">

        {/* Loop through the history array and render each item */}
        {history.map((item, index) => (
          <div className="history-item" key={index}>
            <div className="icon">{item.icon}</div> {/* Milestone Icon */}
            <h3>{item.title}</h3> {/* Milestone Title */}
            <h4>{item.years}</h4> {/* Milestone Time period */}
            <p>{item.content}</p> {/* Milestone Description */}
          </div>
        ))}

      </div>

    </section>
  );
};

export default History;